/* eslint-disable no-unused-vars */
export enum FAVORITE_TYPE {
  PRODUCT = "product",
  HOW_TO_LEARN = "howtolearn",
  LESSON = "lesson",
  INSTRUCTOR = "instructor",
}
